import { FlexContainer, FlexItem, FlexMods, Heading, ifMobileScreen, Paragraph } from 'components/styles'
import { ColorMods } from 'components/styles/primitives/modifiers/text/colorMods'
import { SizeMods } from 'components/styles/primitives/modifiers/size'
import { colors } from 'parameters/ui'
import { useApprovabilityData, useViewState } from '../store'
import { Imposter } from 'components/layout/primitives/Imposter'
import { ApprovabilityCopy } from '../constants'
import { Split, Stack } from 'components/layout/primitives'
import { SpaceProperties } from 'components/styles/definitions/size/typographyScale'
import React from 'react'
import { ifNthOfType } from 'components/styles/primitives/selectors/ifNthOfType'
import { GoTo } from 'ui/inputs/GoTo'

const Help: React.FC<React.PropsWithChildren<unknown>> = () => {
	const [view, { changeView }] = useViewState()
	const [{ prepop }] = useApprovabilityData()
	const query = { loanAmount: prepop.loanAmount }
	return (
		<Imposter format="filled" modifiers={ColorMods({ background: colors.secondaryPurple2 })} visible={view === 'help'}>
			{view === 'help' && (
				<FlexContainer direction="column" justifyContent="space-around" modifiers={SizeMods.FullHeight}>
					<Stack space="small">
						<Heading.H3>{ApprovabilityCopy.Help.title}</Heading.H3>
						<Paragraph small>{ApprovabilityCopy.Help.intro}</Paragraph>
					</Stack>
					{ApprovabilityCopy.Help.steps.map(step => (
						<FlexContainer
							alignItems="flex-start"
							gap={SpaceProperties.Big}
							key={step.title}
							modifiers={ifMobileScreen(
								ifNthOfType(2, FlexMods.Parent({ direction: 'row', reverse: true, gap: SpaceProperties.Small }))
							)}
						>
							<FlexItem grow={1} shrink={0} basis="3em" modifiers={SizeMods({ maxWidth: '25%' })}>
								{step.image}
							</FlexItem>
							<Stack space={0} modifiers={FlexMods.Child({ basis: '50%', grow: 4, shrink: 0 })}>
								<Heading.H5 fontSize="1.25em">{step.title}</Heading.H5>
								<Paragraph small>{step.body}</Paragraph>
							</Stack>
						</FlexContainer>
					))}
					<Paragraph small>{ApprovabilityCopy.Help.Closing}</Paragraph>
					<Split>
						<GoTo onClick={() => changeView('calculator')} direction="left">
							Back
						</GoTo>
						<GoTo direction="none" href={{ pathname: '/explore/loans', query }}>
							Apply Now
						</GoTo>
					</Split>
				</FlexContainer>
			)}
		</Imposter>
	)
}
export default Help
